import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';
import VideoModal from '../../components/VideoModal';

const styles = css`
.VideoSection_item {
  width: 100%;
  margin: 0 0 25px 0;
  @media(min-width: 992px) {
    margin: 0 0 40px 0;
  }
  p {
    padding: 0 0 0 0;
    margin: 0 0 0 0;
    @media(min-width: 992px) {
      padding: 0 0 0 0;
      margin: 0 0 0 0;
    }
  }
}
.videoContainer {
  width: 100%;
  margin: 0 0 10px 0;
  background-size: 100%;
  background-position: center;
  position: relative;
  transition: all .3s ease-out;
  @media(min-width: 992px) {
    margin: 0 0 15px 0;
    cursor: pointer;
  }
  &:hover {
    background-size: 102%;
    transition: all .3s ease-out;

    .Video_overlay {
      background-color: rgba(0, 0, 0, 0.4);
      transition: all .3s ease-out;
      img {
        opacity: .8;
        height: 41px;
        transition: all .3s ease;
      }
    }
  }
}
.Video_overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(51,51,51,0.1);
    top: 0;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    box-shadow: inset 0 5px 20px rgba(51, 51, 51, 0.39);
    transition: all .3s ease-out;
    img {
      opacity: 1;
      height: 38px;
      transition: all .3s ease;
    }
  }
  .Video_caption{
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 2.21px;
    line-height: 25px;
    @media(min-width: 992px) {
      letter-spacing: 3.07px;
      line-height: 20px;
    }
  }
  .PlansMore_btnWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;
    margin:auto;
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
  .PlansMore_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }
  .GalleryVideos_videos{
    max-width: 1300px;
    justify-content: center;
  }
  .Gallery_heading {
    font-family: ${typography.Serif};
    color: ${colors.color1};
    margin: 0 0 30px 0;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 44px;
    }
  }
  .GalleryVideos_buttonWrapper{
    text-align: center !important;
  }

`;

class GalleryVideos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: this.props.videoCount,
    };
  }
  showVideos = () => {
    this.setState({
      limit: Infinity,
    });
  };
  render() {
    const { limit } = this.state;
    const { videos } = this.props;
    return (
      <div className={styles} id="gallery">
        <h2 className="Gallery_heading">Video Gallery</h2>
        <div className="container">
          <div className="GalleryVideos_videos row mx-auto">
            {
              videos.slice(0, limit).map(video => {
                return (
                  <div key={video._id} className="VideoSection_item col-lg-4">
                    <VideoModal
                      video={video.video}
                    >
                      <div
                        className="embed-responsive embed-responsive-16by9 videoContainer"
                        style={{ backgroundImage: `url(${buildThumbnailUrl(get(video, 'image_thumbnail.contentUrl'), { width: 1500, height: 1500, preserve: true })})` }}
                      >
                        <div className="Video_overlay">
                          <img src="/images/youtube-white.svg" alt="Play Icon" />
                        </div>
                      </div>

                    </VideoModal>
                    <p className="Video_caption">{get(video, 'caption')}</p>
                  </div>
                );
              })
            }
          </div>
        </div>
        {
          limit < videos.length &&
          <div className="GalleryVideos_buttonWrapper">
            <span
              className="btn btn-hollow mx-auto my-5"
              role="button"
              tabIndex="0"
              onClick={() => this.showVideos()}
            >Load More</span>
          </div>
        }
      </div>
    );
  }
}

GalleryVideos.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object).isRequired,
  videoCount: PropTypes.number.isRequired,
};

export default GalleryVideos;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/VideoGalleryList.js